import VideoBlockPreview from "./VideoBlockPreview";

export default VideoBlockPreview;